import { useEffect } from 'react';

import { useRouter } from 'next/navigation';

import { LoadingPage } from '../../views/LoadingPage/LoadingPage';

// This is a sub-set of the props for react-router's Redirect component, but it covers what we
// currently use in mykiss.
interface IProps {
  to: string;
}

export const Redirect = ({ to }: IProps) => {
  const router = useRouter();
  useEffect(() => {
    router.push(to);
  }, [router, to]);

  return <LoadingPage />;
};
